<template>
  <Bar v-if="loaded"
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Bar } from 'vue-chartjs/legacy';
import {reportsService} from "@/_services";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'BarChart',
  components: {
    Bar
  },
  props: {
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    loaded: false,
      chartData: null,
      chartOptions: {
        scales: {
          x: {
            grid: {
              display: false,
            },
          },

          y: {
            grid: {
              display: false,
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false
      }
  }),
  async mounted () {
    this.loaded = false;

    try {
      reportsService.getDash().then((data) => {
        this.items = data;

        console.log(this.items)

        this.items.LABELS.datasets[0].borderRadius = 3

        this.chartData = this.items.LABELS

        this.loaded = true
      })
    } catch (e) {
      console.error(e)
    }
  }
}
</script>